// Native & external imports
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  inject,
} from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { ApiCallsService } from "icamppro-shared-components";
import { SubSink } from "subsink";
// Services
import { AppRouterService } from "src/routing/routes-service";
import { CmpAppSettings } from "src/services/cmp-app-settings.service";
import { HelperService } from "src/services/helper.service";

@Component({
  standalone: false,
  selector: "cmp-password-reset",
  templateUrl: "./password-reset.component.html",
})
export class PasswordResetComponent implements OnInit, OnDestroy {
  private formBuilder = inject(UntypedFormBuilder);
  private apiService = inject(ApiCallsService);
  private routerService = inject(AppRouterService);
  private cmpAppSettings = inject(CmpAppSettings);
  private helperService = inject(HelperService);

  @Output() response = new EventEmitter();

  public forgotPasswordForm: UntypedFormGroup;
  public emailError = "";
  public loadingForgotPassword = false;
  public emailSent = false;
  public classNames: { [index: string]: boolean };
  public companyName = "";
  private _subSink = new SubSink();
  constructor() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: [
        null,
        [
          Validators.required,
          Validators.pattern(this.helperService.emailPattern()),
        ],
      ],
    });
    this.classNames = {
      registerEmailFocus: false,
      firstName: false,
      lastName: false,
    };
  }

  ngOnInit() {
    this.companyName = this.cmpAppSettings.getAppSetting("companyName");
    this.emailSent = false;
  }

  ngOnDestroy() {
    this._subSink.unsubscribe();
  }

  /**
   * @method addRemoveClass
   * @description add or remove the input-focused class
   * @param formGroup UntypedFormGroup
   * @param action string
   * @param element string
   * @returns response callback
   */
  public addRemoveClass(
    formGroup: UntypedFormGroup,
    action = "",
    element = "",
  ) {
    this.classNames.emailFocus =
      action === "focus"
        ? true
        : formGroup.controls["email"].value
          ? true
          : false;
  }

  /**
   * @method resetPassword
   * @description Send reset password email to the given email address
   * @param email NgModel
   * @returns void
   */
  public resetPassword() {
    this.emailError = "";
    this.loadingForgotPassword = true;
    const payLoad = this.forgotPasswordForm.value;
    payLoad.scope = "consumer";
    payLoad.isRegistrationPortal = true;
    if (this.forgotPasswordForm.valid) {
      this._subSink.add(
        this.apiService
          .post(this.routerService.backendApiUrl.passwordReset, payLoad)
          .subscribe((response) => {
            if (!response.hasErrors) {
              this.emailSent = true;
              this.helperService.pushGTMEvent("password_request_reset");
            } else {
              if (response.errors.length) {
                this.emailError = `Sorry, we don't recognize this email address.`;
                this.forgotPasswordForm.controls["email"].setErrors({
                  incorrect: true,
                });
              } else {
                this.emailError = response.message;
              }
            }
            this.loadingForgotPassword = false;
          }),
      );
    } else {
      this.helperService.validateFormGroup(this.forgotPasswordForm);
    }
  }

  /**
   * @method cancel
   * @param next string
   * @description Handle cancelling the password reset - to close this UI
   */
  public cancel(next = "") {
    this.response.emit({
      from: "passwordReset",
      value: next,
    });
  }
}
